// import ChatContainer from "components/chat/ChatContainer";
import { useEffect } from "react";

import ChatContainer from "components/chat/ChatContainer";
import FilesControl from "components/file-uploads/FilesControl";
import withAsync from "components/withAsync";
import CargoGroupProvider from "features/cargo-groups/CargoGroupProvider";
import { Prompt } from "react-router-dom";

import useLoadQuoteRequestAndQuote from "../../hooks/quotes/useLoadQuoteRequestAndQuote";
import { useRequestManagementSlices, useRequestManagementSliceSelector } from "../../store/requestManagementStore";
import { updateQuoteRequestActions } from "../../store/updateQuoteRequestSlice";
import PageLayout from "../../views/PageLayout";
import BookQuoteContainer from "./BookQuoteContainer";
import QuoteDetailsContainer from "./QuoteDetailsContainer";
import QuoteManagementAppBar from "./QuoteManagementAppBar";
import QuoteRequestHeader from "./QuoteRequestHeader";
import QuoteSummaryContainer from "./QuoteSummaryContainer";
import ReferencesContainer from "./ReferencesContainer";

const QuoteManagementPage = withAsync({
  useHook: useLoadQuoteRequestAndQuote,
  Component: ({ loadedData }) => {
    useRequestManagementSlices();
    const { isEditing } = useRequestManagementSliceSelector((store) => store.updateQuoteRequestSlice);

    const conversationId = loadedData.quote.conversation_id;
    const { useResetState } = updateQuoteRequestActions;
    const resetState = useResetState();

    useEffect(() => {
      resetState();
      return () => {
        resetState();
      };
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
      <FilesControl fileIds={loadedData.quoteRequest.fileIds ?? []}>
        <CargoGroupProvider
          cargoGroups={loadedData.quoteRequest.cargo_groups}
          quote_request_id={loadedData.quoteRequest.id}
        >
          <PageLayout
            header={[<QuoteManagementAppBar />, <QuoteRequestHeader />]}
            leftContent={[<QuoteSummaryContainer />, <ReferencesContainer />, <QuoteDetailsContainer />]}
            rightContent={[
              <BookQuoteContainer />,
              <div className="max-h-[60%] h-full">
                <ChatContainer conversationId={conversationId?.toString()} maxFiles={4} />,
              </div>,
            ]}
          />
          <Prompt when={isEditing} message="You have unsaved changes. Are you sure you want to leave this page?" />
        </CargoGroupProvider>
      </FilesControl>
    );
  },
});

export default QuoteManagementPage;
